import RouteDirectionViewModel from 'visuris/ViewModels/Route/RouteDirectionViewModel';
import { formatLengthAsKilometer, formatLengthAsMeterWithUnitAndDecimals, formatLengthAsMeter, formatTimeToDays } from 'visuris/Data/Formatters';
import { LengthUnit } from 'visuris/Helpers/Enums';
import * as i18n from 'CMS/core/i18n';

export default class RouteViewModel {

    public directions: RouteDirectionViewModel[];

    public maxTrajectCEMT: string = '';
    public maxTrajectDraught: number = null;
    public maxTrajectHeight: number = null;
    public maxTrajectLength: number = null;
    public maxTrajectWidth: number = null;
    public maxTrajectDraughtSource: string = null;
    public maxTrajectHeightSource: string = null;
    public maxTrajectLengthSource: string = null;
    public maxTrajectWidthSource: string = null;
    public containsTideDep: boolean = null;
    public authorities: string[] = [];

    public totalLocks: number;
    public totalBridges: number;
    public totalTime: number;
    public totalLength: number;

    public hasSameShortestRoute: boolean = false;

    public formattedMaxTrajectDraught(): string {
        if (this.maxTrajectDraught != null) {
            return formatLengthAsMeterWithUnitAndDecimals(this.maxTrajectDraught, LengthUnit.Centimeter);
        }
        const text = i18n.getMessage('VisuRIS.Directions.notavailable');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    public formattedMaxTrajectHeight(): string {
        if (this.maxTrajectHeight != null) {
            return formatLengthAsMeterWithUnitAndDecimals(this.maxTrajectHeight, LengthUnit.Centimeter);
        }
        const text = i18n.getMessage('VisuRIS.Directions.nolimitation');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    public formattedMaxTrajectLength(): string {
        if (this.maxTrajectLength != null) {
            return formatLengthAsMeterWithUnitAndDecimals(this.maxTrajectLength, LengthUnit.Centimeter);
        }
        const text = i18n.getMessage('VisuRIS.Directions.notavailable');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    public formattedMaxTrajectWidth(): string {
        if (this.maxTrajectWidth != null) {
            return formatLengthAsMeterWithUnitAndDecimals(this.maxTrajectWidth, LengthUnit.Centimeter);
        }
        const text = i18n.getMessage('VisuRIS.Directions.notavailable');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    public isMaxTrajectDraughtSourceAllowedDim(): boolean {
        return this.maxTrajectDraughtSource === 'ALLOWED';
    }

    public formattedMaxTrajectDraughtSource(): string {
        if (this.maxTrajectDraughtSource === 'NTS') {
            return i18n.getMessage('VisuRIS.Directions.ntsImpactedDepth');
        } else {
            return i18n.getMessage('VisuRIS.Directions.allowedDepth');
        }
    }

    public isMaxTrajectHeightSourceAllowedDim(): boolean {
        return this.maxTrajectHeightSource === 'ALLOWED';
    }

    public formattedMaxTrajectHeightSource(): string {
        switch (this.maxTrajectHeightSource) {
            case 'NTS':
                return i18n.getMessage('bridge.ntsImapctedHeight');
            case 'MAXIMUM_STATIC':
                return i18n.getMessage('bridge.airdraught');
            case 'MAXIMUM_ACTUAL':
                return i18n.getMessage('bridge.airdraughtDynamicActual');
            case 'MAXIMUM_PREDICTED':
                return i18n.getMessage('bridge.airdraughtDynamicPredicted');
            default:
                return i18n.getMessage('bridge.allowedHeight');
        }
    }

    public isMaxTrajectLengthSourceAllowedDim(): boolean {
        return this.maxTrajectLengthSource === 'ALLOWED';
    }

    public formattedMaxTrajectLengthSource(): string {
        if (this.maxTrajectLengthSource === 'NTS') {
            return i18n.getMessage('VisuRIS.Directions.ntsImpactedLength');
        } else {
            return i18n.getMessage('VisuRIS.Directions.allowedLength');
        }
    }

    public isMaxTrajectWidthSourceAllowedDim(): boolean {
        return this.maxTrajectWidthSource === 'ALLOWED';
    }

    public formattedMaxTrajectWidthSource(): string {
        if (this.maxTrajectWidthSource === 'NTS') {
            return i18n.getMessage('VisuRIS.Directions.ntsImpactedWidth');
        } else if (this.maxTrajectWidthSource === 'MAXIMUM_STATIC') {
            return i18n.getMessage('bridge.clearanceWidth');
        } else {
            return i18n.getMessage('bridge.allowedWidth');
        }
    }

    public formattedTotalTime(): string {
        return formatTimeToDays(this.totalTime);
    }

    public formattedTotalLength(): string {
        if (this.totalLength > 1000) {
            return formatLengthAsKilometer(this.totalLength / 1000, LengthUnit.Kilometer, true, true);
        }
        if (this.totalLength === 0) {
            return '0 km';
        }
        return formatLengthAsMeter(this.totalLength, LengthUnit.Meter, true, true);
    }
}